export default import.meta.ROLLUP_FILE_URL_$6UtFC$ggZWao0xraMGF_A;